import {
  ERROR,
  GET_PROJECT_BUILDING,
  RELOAD_PROJECT_BUILDINGS,
  SET_PROJECT_BUILDINGS_VIEW_MODE, START, SUCCESS
} from '../actions/types';
import { ViewModes } from '../../constants';

const INITIAL_STATE = {
  reload: false,
  viewMode: ViewModes.GRID,
  projectBuilding: null,
};

export default function reducer(state = INITIAL_STATE, action) {
  const data = action.payload?.data;

  switch (action.type) {
    case RELOAD_PROJECT_BUILDINGS:
      return { ...state, reload: action.payload.reload };

    case SET_PROJECT_BUILDINGS_VIEW_MODE:
      return { ...state, viewMode: action.payload.viewMode };

    case GET_PROJECT_BUILDING + START:
      return { ...state };
    case GET_PROJECT_BUILDING + SUCCESS:
      return { ...state, projectBuilding: data.item };
    case GET_PROJECT_BUILDING + ERROR:
      return { ...state };

    default:
      return { ...state };
  }
}
